import { CenterCurrency } from '../center-model/center-currency.model';

export class GatewayTransaction {

    private amount: number;
    private bank: string;
    private centerInternalId: string;
    private centerName: string;
    private country: string;
    private currency: CenterCurrency;
    private dataResponse: string;
    private datetime: number;
    private gateway: string;
    private internalId: string;
    private orderId: string;
    private paymentIdentifier: string;
    private status: string;
    private transactionType: string;

    constructor(amount?: number, bank?: string, centerInternalId?: string, centerName?: string, country?: string, currency?: CenterCurrency, dataResponse?: string, datetime?: number, gateway?: string, internalId?: string, orderId?: string, paymentIdentifier?: string, status?: string, transactionType?: string) {
        this.amount = amount;
        this.bank = bank;
        this.centerInternalId = centerInternalId;
        this.centerName = centerName;
        this.country = country;
        this.currency = currency;
        this.dataResponse = dataResponse;
        this.datetime = datetime;
        this.gateway = gateway;
        this.internalId = internalId;
        this.orderId = orderId;
        this.paymentIdentifier = paymentIdentifier;
        this.status = status;
        this.transactionType = transactionType;
    }

    public get Amount () {
        return this.amount;
    }
    public get Bank () {
        return this.bank;
    }
    public get CenterInternalId () {
        return this.centerInternalId;
    }
    public get CenterName () {
        return this.centerName;
    }
    public get Country () {
        return this.country;
    }
    public get Currency () {
        return this.currency;
    }
    public get DataResponse () {
        return this.dataResponse;
    }
    public get Datetime () {
        return this.datetime;
    }
    public get Gateway () {
        return this.gateway;
    }
    public get InternalId () {
        return this.internalId;
    }
    public get OrderId () {
        return this.orderId;
    }
    public get PaymentIdentifier () {
        return this.paymentIdentifier;
    }
    public get Status () {
        return this.status;
    }
    public get TransactionType () {
        return this.transactionType;
    }

    public set Amount(amount) {
        this.amount = amount;
    }
    public set Bank(bank) {
        this.bank = bank;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set Country(country) {
        this.country = country;
    }
    public set Currency(currency) {
        this.currency = currency;
    }
    public set DataResponse(dataResponse) {
        this.dataResponse = dataResponse;
    }
    public set Datetime(datetime) {
        this.datetime = datetime;
    }
    public set Gateway(gateway) {
        this.gateway = gateway;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set OrderId(orderId) {
        this.orderId = orderId;
    }
    public set PaymentIdentifier(paymentIdentifier) {
        this.paymentIdentifier = paymentIdentifier;
    }
    public set Status(status) {
        this.status = status;
    }
    public set TransactionType(transactionType) {
        this.transactionType = transactionType;
    }

}
